module.exports = {
  cpp: 'cpp',
  python: 'python3.6',
  java: 'java',
  javascript: 'javascript',
};
